"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import _ from "underscore";
import CarrierName from "../carrier_name";
import CarrierInvoiceFormatter from "../../formatters/carrier_invoice";
import generalFormatter from "../../formatters/general";
function displayInvoiceNumber(invoice) {
  return invoice.source_invoice_number || "TBD";
}
function loadIdFormat(loadId) {
  if (loadId.includes("dummy")) {
    return "DRAFT LOAD";
  } else {
    return loadId;
  }
}
function CarrierInvoiceChooserAlreadyAssigned(props) {
  var _a, _b, _c;
  const isManualRegroup = ((_a = props.group) == null ? void 0 : _a.grouping_method) === "manual_regroup";
  const hasUnindexedDocumentsDueToRegroup = isManualRegroup && ((_c = (_b = props.group) == null ? void 0 : _b.documents) != null ? _c : []).some((d) => !d.carrier_invoice_id);
  return /* @__PURE__ */ jsxs("div", { "data-component": "CarrierInvoiceChooserAlreadyAssigned", children: [
    /* @__PURE__ */ jsxs("h6", { className: "carrier-invoice-chooser__already-assigned", children: [
      "Documents are assigned to ",
      CarrierInvoiceFormatter.state(props.invoice),
      " ",
      /* @__PURE__ */ jsx(CarrierName, { carrierID: props.invoice.carrier_id }),
      " invoice #",
      displayInvoiceNumber(props.invoice),
      " ",
      props.additionalInvoiceInfo(props.invoice),
      " ",
      /* @__PURE__ */ jsx("a", { onClick: props.onRequestChange, children: /* @__PURE__ */ jsx("i", { className: "fi-pencil" }) })
    ] }),
    hasUnindexedDocumentsDueToRegroup && /* @__PURE__ */ jsx("div", { className: "alert-box--caution carrier-invoice-chooser__unindexed-notice", children: /* @__PURE__ */ jsx("span", { children: "Not all documents in this group are linked to the above invoice yet \u2014 the rest will be added when you submit." }) })
  ] });
}
function buttonForInvoice(props, invoice) {
  return /* @__PURE__ */ jsx(
    "input",
    {
      type: "radio",
      checked: props.selectedInvoice.id === invoice.id,
      onChange: _.partial(props.invoiceSelected, invoice),
      name: "carrier-invoice-chooser",
      className: "mousetrap"
    }
  );
}
function showInvoice(props, invoice) {
  const formattedState = CarrierInvoiceFormatter.state(invoice);
  let message = formattedState === "received" ? "assigned to a" : "assigned to an";
  if (props.currentlyAssignedInvoice && invoice.id === props.currentlyAssignedInvoice.id) {
    message = "left as assigned to";
  }
  return /* @__PURE__ */ jsx(
    "li",
    {
      className: "carrier-invoice-chooser-invoice",
      children: /* @__PURE__ */ jsxs("label", { className: "carrier-invoice-chooser-invoice-label", children: [
        /* @__PURE__ */ jsx("span", { children: buttonForInvoice(props, invoice) }),
        /* @__PURE__ */ jsxs("span", { children: [
          " ",
          message,
          " ",
          formattedState,
          " ",
          /* @__PURE__ */ jsx(CarrierName, { carrierID: props.carrierID }),
          " ",
          "invoice #",
          invoice.source_invoice_number || "TBD",
          " ",
          additionalInvoiceInfo(props, invoice)
        ] })
      ] })
    },
    "invoice_li_" + invoice.id
  );
}
function additionalInvoiceInfo(props, invoice) {
  var additionalInfo = "\u2013 Load:\xA0" + loadIdFormat(props.loadID);
  if (invoice && invoice.source_invoice_amount) {
    var amount = generalFormatter.currency(invoice.source_invoice_amount);
    additionalInfo += ", Amount:\xA0" + amount;
  }
  if (invoice && invoice.source_invoice_date) {
    var date = generalFormatter.shortDate(invoice.source_invoice_date);
    additionalInfo += ", Date:\xA0" + date;
  }
  return additionalInfo;
}
class CarrierInvoiceChooser extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
    __publicField(this, "startEditing", () => {
      this.setState({ editing: true });
    });
  }
  componentWillReceiveProps() {
    this.setState({ editing: false });
  }
  render() {
    if (this.props.currentlyAssignedInvoice && this.props.selectedInvoice.id === this.props.initialInvoiceId && !this.state.editing) {
      return /* @__PURE__ */ jsx(
        CarrierInvoiceChooserAlreadyAssigned,
        {
          additionalInvoiceInfo: (invoice) => additionalInvoiceInfo(this.props, invoice),
          invoice: this.props.currentlyAssignedInvoice,
          loadID: this.props.loadID,
          group: this.props.group,
          onRequestChange: this.startEditing
        }
      );
    } else if (this.props.noInvoice) {
      return /* @__PURE__ */ jsxs("div", { className: "carrier-invoice-chooser__wrapper", children: [
        /* @__PURE__ */ jsx("h6", { children: "Documents should be:" }),
        /* @__PURE__ */ jsxs("ul", { className: "carrier-invoice-chooser", children: [
          /* @__PURE__ */ jsx("li", { className: "carrier-invoice-chooser-invoice", children: /* @__PURE__ */ jsxs("label", { className: "carrier-invoice-chooser-invoice-label", children: [
            /* @__PURE__ */ jsx("span", { children: buttonForInvoice(this.props, this.props.noInvoice) }),
            /* @__PURE__ */ jsxs("span", { children: [
              " ",
              "assigned directly to the load",
              " ",
              additionalInvoiceInfo(this.props)
            ] })
          ] }) }),
          _.map(
            this.props.invoicesForGroup,
            (invoice) => showInvoice(this.props, invoice)
          )
        ] })
      ] });
    } else {
      return /* @__PURE__ */ jsxs("div", { className: "carrier-invoice-chooser__wrapper", children: [
        /* @__PURE__ */ jsx("h6", { children: "Documents should be:" }),
        /* @__PURE__ */ jsxs("ul", { className: "carrier-invoice-chooser", children: [
          /* @__PURE__ */ jsx("li", { className: "carrier-invoice-chooser-invoice", children: /* @__PURE__ */ jsxs("label", { className: "carrier-invoice-chooser-invoice-label", children: [
            /* @__PURE__ */ jsx("span", { children: buttonForInvoice(this.props, this.props.newInvoice) }),
            /* @__PURE__ */ jsxs("span", { children: [
              " ",
              "assigned to a new",
              " ",
              /* @__PURE__ */ jsx(CarrierName, { carrierID: this.props.carrierID }),
              " invoice",
              " ",
              additionalInvoiceInfo(this.props)
            ] })
          ] }) }),
          _.map(
            this.props.invoicesForGroup,
            (invoice) => showInvoice(this.props, invoice)
          )
        ] })
      ] });
    }
  }
}
export default CarrierInvoiceChooser;
